module.exports = __webpack_public_path__ + "static/media/login.806f55fa.svg";